import { publicRequest } from "../core/services";
const content = {
    contentInfo: (data) => publicRequest.post("/api/content/get-content-info", data),
};
export const apiContent = {
    content,
};
